import { useNavigate } from "react-router-dom";
import Header from "../components/Header";

function Recipes() {
  const navigate = useNavigate();

  const recipes = [
    {
      title: "Liver Cake",
      link: "https://drive.google.com/file/d/1C4t3bCbicL-6UkcZ5MtnRvKl6CQPsNLY/view?usp=sharing",
    },
    {
      title: "Peanut Butter and Carrot Cake",
      link: "https://drive.google.com/file/d/1TBv25VNgeA1O1qJ0m8mmcITbzsza8xxZ/view?usp=sharing",
    },
    {
      title: "Peanut Butter Biscuits",
      link: "https://drive.google.com/file/d/1m-ekP4iEgSct2MvgPCkvLYxTp1ROYev4/view?usp=sharing",
    },
    {
      title: "Tuna Cake",
      link: "https://drive.google.com/file/d/1x81Rc5qPB8Yejwpd_Kt41Ej-VXGK9pUU/view?usp=sharing",
    },
  ];

  return (
    <>
      <Header />
      <div className="min-h-screen bg-gray-50 p-8">
        <button
          onClick={() => navigate("/home")}
          className="mb-6 inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 shadow-sm"
        >
          ← Back to Dashboard
        </button>

        <h1 className="text-4xl font-bold text-gray-800 mb-2">Homemade Recipes</h1>
        <p className="text-lg text-gray-600 mb-8">
          Simple, dog-safe recipes for training treats and enrichment toys.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">Recipe Cards</h2>

        <div className="grid sm:grid-cols-2 gap-4">
          {recipes.map(({ title, link }) => (
            <a
              key={title}
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="block p-4 bg-white border border-gray-200 rounded-lg text-blue-600 hover:border-blue-400 hover:shadow transition text-center font-medium"
            >
              {title}
            </a>
          ))}
        </div>
      </div>
    </>
  );
}

export default Recipes;
